const PLATFORM_ADMIN_EMAILS = new Set([
  "mtantonio3@gmail.com",
  "antonio@selennestrategies.com",
]);

const BLOCKED_ACCESS_STATUSES = new Set(["suspended", "revoked"]);

function normalize(value) {
  return String(value || "").trim().toLowerCase();
}

export function hasSysAdminCredential(currentUser, userData) {
  const email = normalize(currentUser?.email || userData?.email);
  const accessStatus = normalize(userData?.accessStatus);

  return (
    PLATFORM_ADMIN_EMAILS.has(email) &&
    !BLOCKED_ACCESS_STATUSES.has(accessStatus)
  );
}
